<template>
    <div class="ma-4">
      <v-snackbar v-model="msg" top>
        {{ text }}
        <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
      >
      <ClientNav />
      <v-row dense>
        <v-col cols="12" lg="3" xl="2">
          <ClientSide />
        </v-col>
        <v-col cols="12" lg="9" xl="10">
          <v-card class="pa-2" outlined tile height="100%">
          <v-data-table
            :headers="headers"
            :items="serviceLogs"
            sort-by="Date"
            sort-desc
            :loading="isLoading"
            loading-text="Loading Service Logs"
            :search="search"
            height="550"
            
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Service Log</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  clearable
                  @click:clear="callItBack()"
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="100%">
                  <template v-slot:activator="{ on }">
                    <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()"
                  >
                  <v-icon left>add</v-icon>
                  Add Service Log</v-btn
                >
                  </template>
                  <v-card>
                    <v-card-title style="background-color: #2b3990">
                      <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form
                        ref="form"
                        lazy-validation
                      >
                      <v-container>
                        <v-row>
                            <v-col cols="12">
                              <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="newDate"
                                    label="Date of Service"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="newDate"
                                  no-title
                                  scrollable
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(newDate)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <label for="timePicker">Select Start Time: </label>
                                <vue-timepicker
                                  v-model="newTimeIn"
                                  format="hh:mm A"
                                  :minute-interval="minuteInterval"
                                ></vue-timepicker>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <label for="timePicker">Select End Time: </label>
                                <vue-timepicker
                                  v-model="newTimeOut"
                                  format="hh:mm A"
                                  :minute-interval="minuteInterval"
                                ></vue-timepicker>
                            </v-col>
                            
                            <v-col cols="12" md="6">
                                <v-select
                                    label="Total Awake"
                                    :items="hours"
                                    v-model="newTotalAwake"
                                    :rules="requiredField"
                                ></v-select>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-select
                                    label="Total Asleep"
                                    :items="hours"
                                    v-model="newTotalAsleep"
                                    :rules="requiredField"
                                ></v-select>
                            </v-col>

                            <v-col cols="12" sm="6">
                              <v-checkbox
                                label="Click Here to Sign Initials"
                                v-model="newSigned"
                                @click="getStaffSignature()"
                              ></v-checkbox>
                            </v-col>

                            <v-col cols="12" sm="6" v-if="newSigned">
                              <v-img
                                :src="newStaffInitials"
                                
                              ></v-img>
                            </v-col>
                            
                        </v-row>
                      </v-container>
                      </v-form>
                    </v-card-text>
  
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="white--text"
                        color="#259647"
                        @click="addService()"
                        v-if="newService"
                        >Save</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="updateService()"
                        v-if="editService"
                        >Update</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="close"
                        >Cancel</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>
  
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewService(item)">
                mdi-eye
              </v-icon>
              
              <v-icon small @click="deleteService(item)">
                mdi-delete
              </v-icon>
              
            </template>
            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="getServices()">Reset</v-btn>
            </template>
          </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <Foot />
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import ClientNav from "../../components/ClientNav";
  import ClientSide from "../../components/ClientSide";
  import Foot from "../../components/Footer";
  import 'vue2-timepicker/dist/VueTimepicker.css';
  import VueTimepicker from 'vue2-timepicker';  
  // import moment from "moment";
  
  const url = require("../../client_config/config").url;
  
  export default {
    components: {
      ClientNav,
      ClientSide,
      Foot,
      VueTimepicker
    },
    data: function() {
      return {
        headers: [
          {
            text: "Date",
            align: "start",
            sortable: false,
            value: "Date",
          },
          { text: "Time In", value: "TimeIn"},
          { text: "Time Out", value: "TimeOut"},
          { text: "Total Awake", value: "TotalAwake"},
          { text: "Total Asleep", value: "TotalAsleep" },
          { text: "Actions", value: "actions", sortable: false },
        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        dialog: false,
        editService: false,
        newService: false,
        msg: false,
        search: "",
        text: "",
        serviceLogs: [],
        tempData: [],
        clientID: this.$route.params.clientID,
        titleForm: "New Service Log",
        serviceID: "",
        newDate: "",
        newTimeIn: "",
        newTimeOut: "",
        newTotalAwake: "",
        newTotalAsleep: "",
        newSigned: false,
        newStaffInitials: "",
        newAMPM: "",
        staffID: localStorage.getItem('staffId'),
        requiredField: [
            v => !!v || 'This is required',
        ],
        hours: [
          "1.0",
          "1.5",
          "2.0",
          "2.5",
          "3.0",
          "3.5",
          "4.0"
        ],

        isLoading: true,
      };
    },
  
    computed: {
      formTitle() {
        return this.editedIndex != 1 ? "New Item" : "Edit Item";
      },
    },
  
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
  
    created() {
      this.getServices();
    },
  
    methods: {
      initialize() {
        this.services = [];
      },
      validate() {
          return this.$refs.form.validate();
      },
      viewService(item) {
        this.titleForm = "Viewing Service Log"
        this.dialog = true;
        this.editService = true;
        this.newService = false;
        this.newDate = item.Date;
        this.newTimeIn = item.TimeIn;
        this.newTimeOut = item.TimeOut;
        this.newTotalAwake = item.TotalAwake;
        this.newTotalAsleep = item.TotalAsleep;
        this.newSigned = item.Signed;
        this.newStaffInitials = item.StaffInitials;
        this.serviceID = item._id;
      },
      showAdd() {
        this.titleForm = "New Service Log";
        this.newService = true;
        this.editService = false;
      },
  
      deleteService(item) {
        const id = item._id;
        confirm("Are you sure you want to delete this service log?") &&
          this.serviceDelete(id);
      },

      getStaffSignature(){
        axios.get(`${url}/users/${this.staffID}`).then((response) => {
          this.newStaffInitials = response.data.user.Initials
        })
      },  
  
      serviceDelete(id) {
        axios.delete(`${url}/serviceLog/${id}`).then((response) => {
          this.getServices();
          if (response.status == 400) {
            response.json().then(function(data) {
              return data.msg;
            });
          }
          this.msg = true;
          this.text = "The record has been deleted successfully.";
        });
      },
  
      close() {
        this.clear()
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
  
      updateService() {
        var req_body = {
          Date: this.newDate,
          TimeIn: this.newTimeIn,
          TimeOut: this.newTimeOut,
          TotalAwake: this.newTotalAwake,
          TotalAsleep: this.newTotalAsleep,
          Signed: this.newSigned,
          StaffInitials: this.newStaffInitials,
        };
        axios
          .put(`${url}/serviceLog/${this.serviceID}`, req_body)
          .then((response) => {
            this.getServices();
            if (response.status == 400) {
              response.json().then(function(data) {
                alert(data.msg);
              });
            }
            this.clear()
            this.msg = true;
            this.text = "The record has been updated successfully.";
          });
        this.close();
      },
      getServices: function() {
        this.isLoading = true;
        this.serviceLogs = [];
        axios.get(`${url}/serviceLog/client/${this.clientID}`).then(res => {
          this.serviceLogs = res.data.serviceLogs
        })
        .finally(() => (this.isLoading = false));
      },
  
      addService: function() {
        if(this.validate()){
          var req_body = {
            Date: this.newDate,
            TimeIn: this.newTimeIn,
            TimeOut: this.newTimeOut,
            TotalAwake: this.newTotalAwake,
            TotalAsleep: this.newTotalAsleep,
            Signed: this.newSigned,
            StaffInitials: this.newStaffInitials,
            ClientID: this.clientID,
          };
  
          axios.post(`${url}/serviceLog`, req_body).then((res) => {
            this.getServices();
            if (res.status == 400) {
              res.json().then(function(data) {
                this.msg=true;
                this.text = data.msg;
              });
            }
            this.clear()
            this.msg = true;
            this.text = "The new record has been added successfully.";
          });
          this.close();
      } else {
        this.msg = true;
        this.text="Please fill out all required fields"
      }
      },
  
      clear(){
        this.newDate = "";
        this.newTimeIn= "";
        this.newTimeOut= "";
        this.newTotalAwake = "";
        this.newTotalAsleep= "";
        this.newSigned = false;
        this.newStaffInitials= "";
      },
  
    },
  };
  </script>
  <style>
  @media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }
  }
  </style>
  